module.exports = __webpack_public_path__ + "static/ashwagandha-2b7611c42754befa298104cb8be61ce2.svg";